<template>
	<div v-if="isAuthorized">
		<PackSample :settings="settings"></PackSample>
		<br />
	</div>

	<div class="card">
		<div class="card-header">Основные настройки</div>
		<div class="card-body">
			<div class="form-group">
				<label class="form-label">Технологические отступы</label>
				<div class="row">
					<div class="col-lg-3">
						<div class="input-group">
							<span class="input-group-text">сверху</span>
							<input-number
								class="form-control"
								v-model="settings.listMargins['top']"
								:level="getMeasureLevel(settings.measure)"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="input-group">
							<span class="input-group-text">снизу</span>
							<input-number
								class="form-control"
								v-model="settings.listMargins['bottom']"
								:level="getMeasureLevel(settings.measure)"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="input-group">
							<span class="input-group-text">слева</span>
							<input-number
								class="form-control"
								v-model="settings.listMargins['left']"
								:level="getMeasureLevel(settings.measure)"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="input-group">
							<span class="input-group-text">справа</span>
							<input-number
								class="form-control"
								v-model="settings.listMargins['right']"
								:level="getMeasureLevel(settings.measure)"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
				</div>
			</div>

			<div v-if="kindId != 'roll'">
				<label class="form-label">Минимальный-максимальный лист</label>
				<div class="row">
					<div class="col-lg-6">
						<div class="card">
							<div class="card-header">Минимальный</div>
							<div class="card-body">
								<div class="row">
									<div class="col-lg-6">
										<div class="input-group">
											<span class="input-group-text">X</span>
											<input-number
												class="form-control"
												v-model="settings.listMinMax['min']['x']"
												:level="getMeasureLevel(settings.measure)"
											></input-number>
											<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
										</div>
									</div>
									<div class="col-lg-6">
										<div class="input-group">
											<span class="input-group-text">Y</span>
											<input-number
												class="form-control"
												v-model="settings.listMinMax['min']['y']"
												:level="getMeasureLevel(settings.measure)"
											></input-number>
											<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<div class="card">
							<div class="card-header">Максимальный</div>
							<div class="card-body">
								<div class="row">
									<div class="col-lg-6">
										<div class="input-group">
											<span class="input-group-text">X</span>
											<input-number
												class="form-control"
												v-model="settings.listMinMax['max']['x']"
												:level="getMeasureLevel(settings.measure)"
											></input-number>
											<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
										</div>
									</div>
									<div class="col-lg-6">
										<div class="input-group">
											<span class="input-group-text">Y</span>
											<input-number
												class="form-control"
												v-model="settings.listMinMax['max']['y']"
												:level="getMeasureLevel(settings.measure)"
											></input-number>
											<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="form-group" v-if="kindId != 'roll'">
				<label class="form-label">Максимальная область печати</label>
				<div class="row">
					<div class="col-lg-6">
						<div class="input-group">
							<span class="input-group-text">Максимальная ширина формы</span>
							<input-number
								class="form-control"
								v-model="settings.printMax['width']"
								:level="getMeasureLevel(settings.measure)"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
					<div class="col-lg-6">
						<div class="input-group">
							<span class="input-group-text">Максимальная высота формы</span>
							<input-number
								class="form-control"
								v-model="settings.printMax['height']"
								:level="getMeasureLevel(settings.measure)"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="form-group">
				<label class="form-label">Вылеты цвета</label>
				<div class="input-group">
					<input-number
						class="form-control"
						v-model="settings.printMargins"
						:level="getMeasureLevel(settings.measure)"
					></input-number>
					<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
				</div>
			</div>

			<div class="form-group" v-if="kindId == 'sheet'">
				<label class="form-label">Подача листа в печатную машину</label>
				<div class="form-check" v-for="ifeedSide of ['wide', 'narrow']" :key="ifeedSide">
					<input
						class="form-check-input"
						:id="'feedSide-' + ifeedSide"
						type="radio"
						v-model="settings.feedSide"
						:value="ifeedSide"
					/>
					<label class="form-check-label" :for="'feedSide-' + ifeedSide">{{
						{ wide: 'Широкой стороной', narrow: 'Узкой стороной' }[ifeedSide]
					}}</label>
				</div>
			</div>
		</div>
	</div>

	<div class="card">
		<div class="card-header">Размер и установки материала</div>
		<div class="card-body">
			<template v-if="kindId == 'roll'">
				<div class="form-group">
					<label class="form-label">Стоимость материала за м<sup>2</sup></label>
					<div class="input-group">
						<input-number class="form-control" :precision="2" v-model="settings.materialPricePerM2"></input-number>
						<span class="input-group-text">у.е.</span>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="row">
					<div class="col-lg-6">
						<div class="form-group">
							<label class="form-label">Стоимость материала за тонну</label>
							<div class="input-group">
								<input-number class="form-control" :precision="2" v-model="settings.materialPricePerTon"></input-number>
								<span class="input-group-text">у.е.</span>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<div class="form-group">
							<label class="form-label">Плотность материала</label>
							<div class="input-group">
								<input-number class="form-control" v-model="settings.materialDensity"></input-number>
								<span class="input-group-text">гр/м<sup>2</sup></span>
							</div>
						</div>
					</div>
				</div>
			</template>

			<hr />
			<div class="row" v-for="(isourceMaterial, i_sourceMaterial) of sourceMaterials" :key="i_sourceMaterial">
				<div class="col-lg-1">№&nbsp;{{ i_sourceMaterial + 1 }}</div>
				<div class="col-lg-5">
					<div class="form-group">
						<label class="form-label">Размер 1</label>
						<div class="input-group">
							<input-number
								class="form-control"
								:level="getMeasureLevel(settings.measure)"
								v-model="isourceMaterial.size1"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
				</div>
				<div class="col-lg-5">
					<div class="form-group">
						<label class="form-label">Размер 2</label>
						<div class="input-group">
							<input-number
								class="form-control"
								:level="getMeasureLevel(settings.measure)"
								v-model="isourceMaterial.size2"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
				</div>
				<div class="col-lg-1 text-end">
					<button v-if="kindId != 'roll'" @click="deleteSourceMaterial(i_sourceMaterial)" class="btn btn-danger btn-sm">
						Удалить<br />материал
					</button>
				</div>
			</div>
			<button v-if="kindId != 'roll'" @click="addSourceMaterial()" class="btn btn-secondary">Добавить материал</button>
		</div>
	</div>

	<div class="card">
		<div class="card-header">Размер и установки печатных элементов</div>
		<div class="card-body">
			<div class="row" v-for="(iproduct, i_product) of products" :key="i_product">
				<div class="col-lg-1">№&nbsp;{{ i_product + 1 }}</div>
				<div class="col-lg-2">
					<div class="form-group">
						<label class="form-label">Ширина</label>
						<div class="input-group">
							<input-number
								class="form-control"
								:level="getMeasureLevel(settings.measure)"
								v-model="iproduct.width"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
				</div>
				<div class="col-lg-1">
					<button class="btn btn-secondary center-block" @click="swapProductSizes(i_product)">
						<i class="fa fa-exchange"></i>
					</button>
				</div>
				<div class="col-lg-2">
					<div class="form-group">
						<label class="form-label">Высота</label>
						<div class="input-group">
							<input-number
								class="form-control"
								:level="getMeasureLevel(settings.measure)"
								v-model="iproduct.height"
							></input-number>
							<span class="input-group-text">{{ getMeasureLabel(settings.measure) }}</span>
						</div>
					</div>
				</div>
				<div class="col-lg-2">
					<div class="form-group">
						<label class="form-label">Количество</label>
						<div class="input-group">
							<input-number class="form-control" :precision="0" v-model="iproduct.count"></input-number>
							<span class="input-group-text">шт</span>
						</div>
					</div>
				</div>
				<!-- TODO пока не учитываем направление волокон
				<div class="col-lg-2">
					<div class="form-check">
						<input class="form-check-input" id="fibers" type="checkbox" v-model="iproduct.fibers">
						<label class="form-check-label" for="fibers">Учитывать направление волокон</label>
					</div>
				</div>
				-->
				<div class="col-lg-3">
					<div class="form-group">
						<label class="form-label">Примечание</label>
						<input class="form-control" type="text" v-model="iproduct.comment" maxlength="50" />
					</div>
				</div>
				<div class="col-lg-1 text-end">
					<button @click="deleteProduct(i_product)" class="btn btn-danger btn-sm">Удалить<br />изделие</button>
				</div>
			</div>
			<button @click="addProduct()" class="btn btn-secondary">Добавить изделие</button>

			<hr />
			<div class="form-group">
				<label class="form-label">Тестовый набор изделий</label>
				<small>(построчно: ШИРИНА, ВЫСОТА, количество<!--, учитывать направление волокон-->)</small>
				<br />
				<button class="btn btn-secondary" type="button" @click="testRectanglesGet()">
					получить <i class="fa fa-arrow-down"></i>
				</button>
				<button class="btn btn-secondary" type="button" @click="testRectanglesSet()">
					применить <i class="fa fa-arrow-up"></i>
				</button>
				<textarea class="form-control" v-model="testRectangles"></textarea>
			</div>
			<hr />

			<div class="row">
				<div class="col-lg-6" v-if="kindId == 'sheet'">
					<div class="form-group">
						<label class="form-label">Переворот листа</label>
						<div class="form-check" v-for="iturn of ['oneSide', 'alien', 'selfAuto', 'selfForce', 'head']" :key="iturn">
							<input
								class="form-check-input"
								:id="'turn' + iturn"
								type="radio"
								v-model="settings.turn"
								:value="iturn"
							/>
							<label class="form-check-label" :for="'turn' + iturn">
								{{
									{
										oneSide: 'Односторонняя печать',
										alien: 'Двусторонняя печать с чужим оборотом',
										selfAuto: 'Двусторонняя печать со своим оборотом автоматически',
										selfForce: 'Двусторонняя печать со своим оборотом принудительно',
										head: 'Двусторонняя печать через голову',
									}[iturn]
								}}
							</label>
						</div>
					</div>
				</div>
				<div class="col-lg-6">
					<div class="form-group">
						<label class="form-label">Поворот элементов</label>
						<div class="form-check" v-for="irotate of ['enabled', 'disabled', 'fibers']" :key="irotate">
							<input
								class="form-check-input"
								:id="'rotate' + irotate"
								type="radio"
								v-model="settings.rotate"
								:value="irotate"
							/>
							<label class="form-check-label" :for="'rotate' + irotate">
								{{
									{
										enabled: 'Разрешен',
										disabled: 'Запрещен',
										fibers: 'Сохранить направление волокон',
									}[irotate]
								}}
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-if="v$.$error" class="alert alert-danger">
		<span v-if="!canPack">Недостаточно данных для раскладки.<br /></span>
		<span v-if="v$.settings.turn.selfAuto.$invalid"
			>Печать со своим оборотом невозможна (цветность с одной стороны).<br
		/></span>
		<span v-if="v$.sourceMaterials.$error">Не заданы материалы.<br /></span>
		<span v-if="v$.products.required.$invalid">Не заданы элементы.<br /></span>
		<template v-if="kindId === 'roll'">
			<span v-if="v$.settings.materialPricePerM2.$error">Укажите стоимость материала.<br /></span>
		</template>
		<template v-else>
			<span v-if="v$.settings.listMinMax.$error"
				>Значения минимального-максимального листа не должны быть нулевыми и минимальный лист не должен быть больше
				максимального.<br
			/></span>
			<span v-if="v$.settings.materialPricePerTon.$error">Укажите стоимость материала.<br /></span>
			<span v-if="v$.settings.materialDensity.$error">Укажите плотность материала.<br /></span>
			<span v-if="v$.settings.printMax.$error"
				>Значения максимальной области печати не должны быть нулевыми.<br
			/></span>
		</template>
	</div>

	<div>
		<button class="btn btn-primary" @click="pack()">Раскладка</button>
		<button class="btn btn-secondary" @click="newSample = getNewSample()" v-if="isAuthorized">Создать шаблон</button>
	</div>

	<br />

	<template v-if="isWaitPack">
		<div class="progress">
			<div
				class="progress-bar progress-bar-striped progress-bar-animated"
				role="progressbar"
				:style="{ width: packProgress + '%' }"
			>
				{{ packProgressDisplay }}%
			</div>
		</div>
	</template>
	<div v-if="packResult">
		<div class="alert alert-success">
			Исходные данные сохранены в сессии браузера.<br />
			<template v-if="kindId == 'sheet'">
				Лист (материал):
				<span v-if="packResult.generated">{{ packResult.packListId }} ({{ packResult.sourceListId }})</span><br />
				Цена за лист: <span v-if="packResult.generated">{{ currency(packResult.generated.listPrice) }} у.е.</span><br />
			</template>
			Итоговая раскладка:
			<a href="#" v-if="packResult.generated" @click.prevent="showDetailResult = true">см. детально</a>
		</div>
		<div
			class="alert alert-danger"
			v-if="
				packResult.generated && packResult.algo && packResult.generated.info[packResult.algo].availRectangles.length > 0
			"
		>
			Не удалось разложить следующие элементы:
			<ul>
				<li v-for="irect of packResult.generated.info[packResult.algo].availRectangles" :key="irect.id">
					{{ irect.id }}
				</li>
			</ul>
		</div>
		<div
			class="alert alert-danger"
			v-if="
				packResult.generated &&
				packResult.algo &&
				settings.turn == 'selfAuto' &&
				packResult.generated.dest[packResult.algo].length > 1
			"
		>
			Включена автоматическая двусторонняя печать со своим оборотом, но не удалось разложить все элементы на один лист.
		</div>
		<AnimatedModal v-if="showDetailResult" :open="showDetailResult" @close="showDetailResult = false">
			<template v-slot:header>
				{{ packResult.packListId }} ({{ packResult.sourceListId }})
				<!-- !!! для отладки (переключение печатного листа)
				если запрещен поворот элементов относительно друг дружки, то выведутся одинаковые корзины с по-разному повернутыми элементами
				<select class="form-select" v-model="packResult.generated">
					<option :value="null">[печатный лист (материал)]</option>

					<option
						v-for="(iresultBin, i_resultBin) of packResult.packLists"
						:key="i_resultBin"
						:value="iresultBin.generated"
					>
						{{ iresultBin.packListId }} ({{ iresultBin.sourceListId }})
					</option>
				</select>
				-->
				<!-- !!! для отладки (переключение алгоритма) -->
				<select class="form-select" v-model="packResult.algo">
					<option :value="null">[algo]</option>
					<template v-if="packResult.generated">
						<option
							v-for="(ialg, i_alg) of packResult.generated.dest as Record<string, AnyType>"
							:key="i_alg"
							:value="i_alg"
						>
							{{ getAlgoTitle(i_alg) }} ({{ ialg.length }})
						</option>
					</template>
				</select>

				<template v-if="kindId == 'roll'">
					<div v-if="packResult.algo">
						Лист (материал): <span>{{ showListSize(packResult, Measure.mm) }} ({{ packResult.sourceListId }})</span
						><br />
						Цена за лист: <span>{{ currency(calcRollPrice()) }} у.е.</span><br />
					</div>
				</template>
			</template>
			<template v-slot:body>
				<PackResult :result="packResult"></PackResult>
			</template>
		</AnimatedModal>
	</div>
</template>
<script lang="ts" setup>
import { Measure } from '@/common/measure';
import AnimatedModal from '@/components/AnimatedModal.vue';
import inputNumber from '@/components/input-number.vue';
import PackResult from '@/components/pack-result.vue';
import type { PackResult as PackResultType } from '@/lib/calculator-pack';
import { currency } from '@/lib/currency';
import { loadWorkerVersions, type AnyType } from '@/lib/helpers';
import type { MaterialParams } from '@/lib/material';
import {
	getAlgoTitle,
	getPackLists,
	getPrintLists,
	getRectangle,
	isWaitPack,
	packProgress,
	packProgressDisplay,
	showListSize,
	startPackWorker,
} from '@/lib/pack';
import { getMeasureLabel, getMeasureLevel } from '@/lib/typography';
import useVuelidate from '@vuelidate/core';
import { helpers, minValue, required } from '@vuelidate/validators';
import { computed, inject, ref, watch } from 'vue';
import {
	addProduct,
	addSourceMaterial,
	getNewSample,
	getRectangles,
	getSourceMaterial,
	getSourceMaterialsFlat,
	newSample,
	products,
	setPack,
	settings,
	sourceMaterials,
} from './common';
import PackSample from './pack-sample.vue';

const jsParams = inject('jsParams') as AnyType;

// TODO спрятать тестовый функционал
const testRectangles = ref(''); // тестовый текстовый импорт/экспорт прямоугольников

const isAuthorized = ref(jsParams['isAuthorized']);

const kindId = ref(jsParams['kindId']);
const showDetailResult = ref(false);

/*
TODO резка изделий/элементов невозможна для листовой (для рулонной можно),
			нужно проверять все ли элементы уместятся на подготовленных печатных листах,
			хотя, для рулонной тоже понадобится проверка, если выключена возможность склейки
*/

const packResult = ref<PackResultType | null>();

const v$ = useVuelidate(
	computed(() => {
		const currentValidators: AnyType = {};

		currentValidators.sourceMaterials = {
			required,
			$each: helpers.forEach({
				size1: {
					required,
					between: minValue(1),
				},
				size2: {
					required,
					between: minValue(1),
				},
			}),
		};

		currentValidators.products = {
			required,
			$each: helpers.forEach({
				width: {
					required,
					between: minValue(1),
				},
				height: {
					required,
					between: minValue(1),
				},
				count: {
					required,
					between: minValue(1),
				},
			}),
		};

		currentValidators.settings = {
			turn: {
				selfAuto: () => {
					if (settings.value.turn !== 'selfAuto') {
						return true;
					}

					// TODO Материал должен быть 2 сторонним (печать и так двусторонняя, эта проверка понадобится только в калькуляторе)

					// если цветность с одной стороны, то печать со своим оборотом невозможна
					return settings.value.color > 1;
				},
			},
		};

		if (kindId.value === 'roll') {
			currentValidators.settings.materialPricePerM2 = {
				required,
			};
		} else {
			currentValidators.settings.listMinMax = {
				min: {
					x: {
						required,
						between: minValue(1),
					},
					y: {
						required,
						between: minValue(1),
					},
				},
				max: {
					x: {
						required,
						between: minValue(1),
					},
					y: {
						required,
						between: minValue(1),
					},
				},
				minmax: function () {
					// min не должен превышать max
					return (
						(settings.value.listMinMax.min.x <= settings.value.listMinMax.max.x &&
							settings.value.listMinMax.min.y <= settings.value.listMinMax.max.y) ||
						(settings.value.listMinMax.min.x <= settings.value.listMinMax.max.y &&
							settings.value.listMinMax.min.y <= settings.value.listMinMax.max.x)
					);
				},
			};

			currentValidators.settings.printMax = {
				width: {
					required,
					between: minValue(1),
				},
				height: {
					required,
					between: minValue(1),
				},
			};

			currentValidators.settings.materialPricePerTon = {
				required,
			};
			currentValidators.settings.materialDensity = {
				required,
			};
		}

		// TODO проверять чтобы технологические отступы не "съедали" полностью область печати

		return currentValidators;
	}),
	{
		sourceMaterials,
		products,
		settings,
	},
);

function testRectanglesGet() {
	const rectangles = products.value.map(prod => {
		// TODO когда-нибудь потом надо будет учитывать направление волокон
		return (
			prod.width + ', ' + prod.height + ', ' + prod.count /*+ ', ' + (prod.fibers ? '1' : '0')*/ + ', ' + prod.comment
		);
	});
	testRectangles.value = rectangles.join('\n');
}
function testRectanglesSet() {
	const rectangles = <AnyType[]>[];
	const rows = testRectangles.value.split('\n').filter(function (row) {
		return !!row.replace(/\s+/g, '');
	});
	rows.forEach(row => {
		// TODO когда-нибудь потом надо будет учитывать направление волокон (в начале не 3, а 4 числа, то есть +1)
		const commentIndex = 3;
		// FIXME в комментарии могут быть запятые (по другому резать на части)
		const rectangle = row.split(',').map(function (col, i_col) {
			const cell = col.replace(/^\s*(.+?)\s*$/, '$1');
			return i_col < commentIndex ? parseInt(cell) : cell;
		}) as number[];
		if (!isNaN(rectangle[0]) && !isNaN(rectangle[1])) {
			rectangles.push(
				getRectangle(
					rectangle[0],
					rectangle[1],
					rectangle[2] || 1,
					/*rectangle[3] || */ false,
					rectangle[commentIndex].toString() || '',
				),
			);
		}
	});
	products.value = [];
	rectangles.forEach(rect => {
		addProduct(rect.width, rect.height, rect.count, rect.fibers, rect.comment);
	});
}

function writePack(data: AnyType) {
	sessionStorage.setItem('pack-' + kindId.value, JSON.stringify(data));
}

function readPack() {
	const packX = sessionStorage.getItem('pack-' + kindId.value);
	if (packX) {
		try {
			return JSON.parse(packX);
		} catch (e) {
			console.log(e);
		}
	}
	return false;
}

function deleteProduct(index: number) {
	if (products.value.length > 1) {
		products.value.splice(index, 1);
	}
}

function swapProductSizes(index: number) {
	Object.assign(products.value[index], {
		width: products.value[index].height,
		height: products.value[index].width,
	});
}

function deleteSourceMaterial(index: number) {
	if (sourceMaterials.value.length > 1) {
		sourceMaterials.value.splice(index, 1);
	}
}

/**
 * Расчет стоимости листа из отрезанного рулона (по цене за м2).
 */
function calcRollPrice() {
	if (!packResult.value?.algo) {
		return;
	}
	const list = packResult.value.generated.dest[packResult.value.algo][0].packList;
	return ((list.width * list.height) / 1000000) * packResult.value.generated.listPrice;
}

function pack() {
	if (isWaitPack.value) {
		// еще не все результаты получены
		return;
	}
	packResult.value = null;

	v$.value.$touch();
	if (!canPack.value) {
		return;
	}
	v$.value.$reset();

	const rectangles = getRectangles();

	// сохранение в сессии
	const savedPack = {
		settings: settings.value,
		rectangles: rectangles,
		materials: getSourceMaterialsFlat(),
	};
	writePack(savedPack);

	const materialParamsBase =
		kindId.value == 'roll'
			? { pricePerM2: settings.value.materialPricePerM2 }
			: { pricePerTon: settings.value.materialPricePerTon, density: settings.value.materialDensity };
	const materialParamsArray = sourceMaterials.value.map(() => ({ ...materialParamsBase }) as MaterialParams);
	const printLists = getPrintLists(sourceMaterials.value, settings.value.listMinMax, materialParamsArray);
	const packLists = getPackLists(printLists, settings.value.feedSide);

	packResult.value = {
		kindId: kindId.value,
		tryOptimization: kindId.value === 'roll',
		maxBins: kindId.value == 'sheet' ? Infinity : 1,
		packLists: packLists,
		printMargins: settings.value.printMargins,
		listMargins: settings.value.listMargins,
		printMax: settings.value.printMax,
		feedSide: settings.value.feedSide,
		turn: settings.value.turn,
		needTurnSelf: ['selfAuto', 'selfForce'].includes(settings.value.turn),
		rotate: settings.value.rotate,

		lists: [], // результаты по всем корзинам
		// packListId тут имеет смысл, когда в раскладку передается только один лист
		packListId: null,
		algo: null,
		generated: null,
	};
	startPackWorker(packResult.value!, rectangles);
}

// «Переворот листа»: Односторонняя печать – цветность с одной стороны, двусторонняя – цветность с двух сторон.
watch(
	() => settings.value?.turn,
	newTurn => {
		if (!newTurn) {
			return;
		}
		settings.value.color = newTurn === 'oneSide' ? 1 : 2;
	},
	{ immediate: true },
);

const canPack = computed(() => {
	return !v$.value.sourceMaterials.$invalid && !v$.value.products.$invalid && !v$.value.settings.$invalid;
});

loadWorkerVersions(jsParams['workerVersions']);

const _settings = jsParams['settings'] || {};

// чтение сохранения из сессии
let savedPack = readPack();
if (!savedPack) {
	savedPack = {};
}
if (savedPack['settings']) {
	Object.assign(_settings, savedPack['settings']);
}
if (!savedPack['materials']) {
	let _sourceMaterials: AnyType[] = jsParams['sourceMaterials'] || [];
	if (kindId.value == 'roll' && _sourceMaterials.length < 1) {
		_sourceMaterials = [[null, null]];
	}
	sourceMaterials.value = _sourceMaterials.map(sourceMaterial => {
		return getSourceMaterial(sourceMaterial.size1, sourceMaterial.size2);
	});
}

if (kindId.value === 'roll') {
	_settings.feedSide = 'narrow';
	_settings.turn = 'oneSide';
	// возможно, по ширине где-то понадобятся проверки
	_settings.listMinMax.min.x = 1;
	_settings.listMinMax.max.x = Infinity;
	_settings.listMinMax.min.y = 1;
	_settings.listMinMax.max.y = Infinity;
}

setPack(_settings, savedPack['rectangles'], savedPack['materials']);
</script>
